<template>
<div>
  <NuxtLayout>
    <template #body_page>
    <div class="page-travel-guide">
      <BannerWithBreadcrumbs2 :breadcrumbs="breadcrumbs">
        <template #left-banner>{{ contents.title }}</template>
        <template #right-banner>
          <button @click="customTripSubmit" class="button button-primary tl-mt-20">Start Designing Your Own Trip</button>
        </template>
      </BannerWithBreadcrumbs2>
      <div class="container">
        <BodyRightSideBar>
          <template #body>
            <CollapseGroup :toggleAllPanelExpand="expandAll" groupName="timeline" class="travel-guide">
              <Collapse
                :triggerExpand="itemDefaultExp.includes(index)"
                :index="index"
                :id="item.url"
                :expanded="true"
                v-for="(item, index) in contents.items"
                :key="index"
                mobileDisplayBlock
              >
                <template #title>
                  <h3 class="fs-18 fw-700 lh-1">
                    {{ item.title }}
                  </h3>
                </template>
                <template #icon> See details </template>
                <template #icon-expanded> Hide details </template>
                <template #content>
                  <div class="inner">
                    <div v-html="item.content"></div>
                  </div>
                </template>
              </Collapse>
            </CollapseGroup>
          </template>
          <template #sidebar>
            <div class="sticky top-70">
              <DesignBox :galleryTypes="countryName" :countryName="countryName1" />
            </div>
          </template>
        </BodyRightSideBar>
        <div class="mb-60">
          <SectionSuggestTrips
            :listTrips="cardDataList"
            :title="`Top Tours in <span class='ttc'>${countryName1}</span>`"
            :url="goToGallery"
            heap-source="suggest-travel-guide"
          />

          <client-only>
              <div v-if="isCountryPage && showBlogSection" class="mt-60">
                <Blog :category="countryName" :countryName="countryName1" @hiddenBlog="hiddenBlogSection" />
              </div>
          </client-only>
        </div>
      </div>
    </div>
    </template>
  </NuxtLayout>
</div>
</template>

<script setup>
import { computed, onMounted, provide, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
import BodyRightSideBar from '~/components/globals/layout/BodyRightSideBar/BodyRightSideBar'
import Blog from '~/components/sections/SectionBlog/SectionBlog.vue'
import SectionSuggestTrips from '~/components/sections/SectionSuggestTrips/SectionSuggestTrips.vue'
import BannerWithBreadcrumbs2 from '~/components/ui/banners/BannerWithBreadcrumbs2'
import Collapse from '~/components/ui/collapse/Collapse'
import CollapseGroup from '~/components/ui/collapse/CollapseGroup'
import destinationsApi from '~/composables/api/destinationsApi'
import galleryApi from '~/composables/api/galleryApi'
import { isEmpty, scrollToHash } from '~/helper'

import DesignBox from '~/components/pages/TravelGuide/sidebar/DesignBox.vue'
import { debounceHeapTracking } from '~/mixins/heap'
import { DEFINE_META_TAG } from '~/constant/common'
import {useCurrenciesStore} from '~/store/pinia/currencies'
import { useGeneralInfoStore } from '~/store/pinia/generalInfo'

// ---Define---
const route = useRoute()
const router = useRouter()
const itemDefaultExp = ref([])
const generalStore = useGeneralInfoStore()

// const userType = getCookie('dj_user_type=')

const countryName = route.params.country
const countryDestination = ref('')
const pageInfo = ref({})
const isCountryPage = ref(false)
//const breadcrumbs = ref([])
const countryName1 = ref('')
const apiLoaded = ref(false)
const {
  public: { publicDomain },
} = useRuntimeConfig()
const currenciesStore = useCurrenciesStore()

const selectedCurrency = computed(() => {
  // return store.getters['currenciesStore/getCurrencySelected']
  return currenciesStore.getCurrencySelected
})

const breadcrumbs = computed(() => [
  {
    link: `/${countryName}-tours`,
    title: countryName1.value + ' Tours',
  },
  {
    link: '',
    title: contents.value.title,
  },
])

const goToGallery = computed(() => {
  // return { path: `/${countryName}-tours` }
  return { name: 'types-gallery', params: { types_: countryName } }
})

const titlePage = computed(() => {
  return 'The Best ' + countryName.charAt(0).toUpperCase() + countryName.slice(1) + ' Travel Guide | Designer Journeys'
})
const descriptionPage = computed(() => {
  return (
    'Discover extraordinary experiences with our ' +
    countryName.charAt(0).toUpperCase() +
    countryName.slice(1) +
    ' Travel Guide. Explore top activities, eat and see sights curated by Local Designers.'
  )
})
const contents = ref({})
const cardDataList = ref({})

// Expand Collapse
const expandAll = ref(true)

const shouldCollapseExpand = () => {
  if (!route.hash && !itemDefaultExp.value.includes(0)) {
    itemDefaultExp.value.push(0)
    return
  }
  contents.value.items?.map((item, index) => {
    if (route.hash === `#${item.url}` && !itemDefaultExp.value.includes(index)) {
      itemDefaultExp.value.push(index)
    }
  })
}

const showBlogSection = ref(true)
const hiddenBlogSection = (length) => {
  showBlogSection.value = length >= 1
}

const customTripSubmit = () => {
  debounceHeapTracking('View Enquiry', {
    source_widget: 'Travel Guide Top CTA',
    source_type: route.name,
    type: 'b2c',
    destination: countryName1.value || '',
  })
  debounceAmplitudeScriptTracking('View Enquiry', {
    source_widget: 'Travel Guide Top CTA',
    source_type: route.name,
    type: 'b2c',
    destination: countryName1.value || '',
  })
  const url = {
    name: 'enquiry-submit-destination',
    params: { galleryTypes: countryName },
  }
  router.push(url)
}
const getGalleryPage = async (param) => {
  try {
    let resp = null
    let slug = param
    if (process.server && process.PAGE_SETTINGS) {
      //let pageSettings = JSON.parse(process.PAGE_SETTINGS) || {}
      let pageSettingsList = process.PAGE_SETTINGS
      if (pageSettingsList.hasOwnProperty(slug)) {
        resp = pageSettingsList[slug]
      }
    }
    else if (process.client && window.page_settings && window.page_settings.hasOwnProperty(slug)) {
      resp = window.page_settings[slug]
    }

    if (!resp) {
      resp = (await galleryApi.getGalleryPage(param)).data.value?.data
    }
    //const resp = (await galleryApi.getGalleryPage(param)).data.value
    if(isEmpty(resp)) {
      return null
    }
    else if (process.client) {
      if (!window.page_settings) {
        window.page_settings = {}
      }

      window.page_settings[slug] = resp
    }

    countryDestination.value = resp.filter_options.destination.map((item) => item).join() || undefined
    isCountryPage.value = resp.settings.page_type === 'country'

    countryName1.value = resp.name.lastIndexOf(' Tours') !== -1 ? resp.name.substring(0, resp.name.lastIndexOf(' Tours')) : resp.name

    return resp
  } catch (e) {
    console.log(e.message)
  }
}
const getTravelGuide = async (params) => {
  try {
    const { data: resp } = await destinationsApi.getTravelGuide(params)
    contents.value = resp.value.data
    if (!resp.value.data.items) {
      // navigateTo({name: 'trip-gallery'})
      // router.push({
      //   name: 'types-gallery',
      //   params: { types_: route.params.country },
      // })
      return
    }
    apiLoaded.value = true
  } catch (e) {
    console.log(e)
    // navigateTo({name: 'trip-gallery'})
    // router.push({
    //   name: 'types-gallery',
    //   params: { types_: route.params.country },
    // })
  }
}
const getDataTrips = async () => {
  try {
    const params = {
      limit: 4,
      sort: 'popular',
      currency: selectedCurrency.value.code,
      destination: countryDestination.value,
    }
    const resp = (await galleryApi.getTripList('trips', params)).data.value
    cardDataList.value = resp?.data || {}
  } catch (e) {
    console.log(e)
  }
}

provide('pageLoaded', apiLoaded)

onMounted(async () => {
  debounceAmplitudeScriptTracking("View Travel Guide")
  if(isEmpty(pageInfo.value)) return
  let aLink = document.querySelectorAll('.travel-guide a')
  aLink.forEach((item) => {
    let aHref = item.getAttribute('href')
    if (aHref && aHref.indexOf('/') !== 0 && aHref.indexOf('#') !== 0) {
      let idx = aHref.indexOf('designerjourneys.com/')
      if (-1 === idx || idx > 30) {
        item.setAttribute('rel', 'noreferrer noopener')
        item.setAttribute('target', '_blank')
      }
    }
  })

  setTimeout(async () => {
    expandAll.value = false
    shouldCollapseExpand()
    await nextTick(() => {
      scrollToHash(route.hash, 500)
    })
  }, 2000)
})

const canonical = publicDomain + route.path
useHead({
  htmlAttrs: {
    lang: 'en',
  },
  link: [
    {
      rel: 'icon',
      type: 'image/x-icon',
      href: '/favicon.ico'
    },
    {
      rel: 'canonical',
      href: `${canonical}`,
      hreflang: 'en'
    },
    { rel: 'image_src',
      href: computed(()=>contents.value.meta_image),
    }
  ],
  title: titlePage.value,
  meta: [
    ...DEFINE_META_TAG,
    {
      name: 'robots',
      content: useAppConfig().disableBotsIndexing == 1 ? 'NOINDEX, NOFOLLOW' : 'INDEX, FOLLOW'
    },
    {
      name: `title`,
      content: titlePage.value,
    },
    {
      name: `description`,
      content: descriptionPage.value,
    },
  ],
})
useSeoMeta({
  ogTitle:  computed(()=> titlePage.value),
  ogDescription:  computed(()=> descriptionPage.value),
  ogType: 'website',
  ogUrl: `${publicDomain}${route.fullPath}`,
  ogSiteName: 'Designer Journeys',
  ogImage: computed(()=>contents.value.meta_image),
  fbAppId: '452745475618385',
  href: `${publicDomain}${route.fullPath}`,
  twitterTitle: computed(()=> titlePage.value),
  twitterDescription: descriptionPage.value,
  twitterImageAlt: computed(()=> titlePage.value),
  twitterCard: 'summary',
  twitterImage: computed(()=>contents.value.meta_image),
})

const resp = await getGalleryPage(`/${countryName}-tours`)
if(isEmpty(resp)) {
  navigateTo({name: 'trip-gallery'})
} else {
  pageInfo.value = resp
  await Promise.all([
    getTravelGuide({
      country_url: countryName,
      region_id: pageInfo.value.filter_options.region_id,
    }),
    getDataTrips(),
  ])
}
generalStore.setLoading(false)
</script>

<style lang="scss" scoped>
.page-travel-guide {
  background-color: $background; // Wave 5A cream canvas (--dj-bg seam, W7-ready); cream-deep banner sits on top
}
a {
  text-decoration: underline !important; // long-form travel-guide prose links keep underlines for readability
  color: $foreground;
}
</style>
